import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import i18nContext from 'components/i18n-context';
import { formatDate } from 'services/utils';
import './styles.scss';

const DocumentRequestHeader = observer(({ expiresAt, transactionId, showDeadline = true, showTransaction = true }) => {
  const i18n = useContext(i18nContext);

  const formattedDate = formatDate(expiresAt);

  // Don't render if nothing to show
  if (!showDeadline && !showTransaction) return null;

  return (
    <div className='document-request-header-info'>
      <div className='deadline-info'>
        <span className='subtitle'>
          {i18n.getMessage('documentRequest.subtitle')}
          <strong className='deadline-text'> {formattedDate}</strong>
        </span>
      </div>
      {showTransaction && transactionId && (
        <div className='transaction-info'>
          <span className='transaction-label'>Transaction ID:</span>
          <span className='transaction-id'>{transactionId}</span>
        </div>
      )}
    </div>
  );
});

export default DocumentRequestHeader;
